export const UPDATE_ACCOUNT_DETAILS = "UPDATE_ACCOUNT_DETAILS"
export const UPDATE_ACCOUNT_DETAILS_SUCCESS = "UPDATE_ACCOUNT_DETAILS_SUCCESS"
export const UPDATE_ACCOUNT_DETAILS_FAIL = "UPDATE_ACCOUNT_DETAILS_FAIL"
export const CLEAR_ACCOUNT = "CLEAR_ACCOUNT"

export const UPDATE_EDITOR_DETAILS = "UPDATE_EDITOR_DETAILS"
export const UPDATE_EDITOR_DETAILS_SUCCESS = "UPDATE_EDITOR_DETAILS_SUCCESS"
export const UPDATE_EDITOR_DETAILS_FAIL = "UPDATE_EDITOR_DETAILS_FAIL"
export const CLEAR_EDITOR = "CLEAR_EDITOR"